import "./RoboticsCourseD1.module.css";
import Header from "@/reusable_sections/Header";
import RoboticsCourseD1Detail from "./sections/RoboticsCourseD1Detail";
import Footer from "@/reusable_sections/Footer";
export default function RoboticsCourseD1Page() {
  return <div>
      <Header />
      <RoboticsCourseD1Detail />
      <Footer />
    </div>;
}